import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'OrganizationToolbarsPage.Landing.Title',
    defaultMessage: 'Clients'
  },
  description: {
    id: 'OrganizationToolbarsPage.Landing.Description',
    defaultMessage:
      'By adding a client to your organization, users will be able to access all of the wonderful features of Workgrid directly from your intranet.'
  },
  installation: {
    id: 'OrganizationToolbarsPage.Landing.Installation',
    defaultMessage: 'Client Installation Guide'
  },
  readDocumentation: {
    id: 'OrganizationToolbarsPage.Landing.ReadDocumentation',
    defaultMessage: 'Read through our helpful documentation to learn how to create and manage your client.'
  },
  addYourFirst: {
    id: 'OrganizationToolbarsPage.Landing.AddYourFirst',
    defaultMessage: 'Add your first client'
  },
  addAToolbar: {
    id: 'OrganizationToolbarsPage.Landing.AddAToolbar',
    defaultMessage: 'Add a Client'
  }
})
